<template>
  <div class='lib__form__main' data-cy='contact-component'>
    <ValidationObserver ref='validator' slim>
      <div class='lib__form__main__content'>
        <header class='lib__form__main__header'>
          <h2 class='lib__h2'>{{ $t('prosumerDeclaration.installation.title') }}</h2>
        </header>
        <TechnicalInformationComponent v-model='installationState.technicalInformation' />
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang='ts'>
import { Component } from 'vue-property-decorator'
import Step from '@/components/steps/Step'
import { State } from 'vuex-class'
import { InstallationInformation } from '@/models/prosumer-declaration/prosumer-declaration'
import TechnicalInformationComponent from '@/components/inputs/ProsumerDeclaration/TechnicalInformationComponent.vue'

@Component({
  name: 'installation-step',
  components: {
    TechnicalInformationComponent
  }
})
export default class InstallationStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'prosumerDeclaration' }) public requestId!: string
  @State('installation', { namespace: 'prosumerDeclaration/installation' })
  public installationState!: InstallationInformation
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
  }

  public async save(next: boolean, isValid: boolean) {
    if (next && isValid) {
      this.$appInsights.trackEvent('ProsumerDeclaration_StepInstallation_Validated', {
        Segment: 'ProsumerDeclaration',
        WebRef: this.requestId
      })
    }
  }

  //#endregion
}
</script>
